import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrl: './delete-confirm-dialog.component.scss',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  encapsulation: ViewEncapsulation.None
})
export class DeleteConfirmDialogComponent {
  buttonValue: string = 'Delete';

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; buttonValue?: string }
  ) {
    if (data.buttonValue) {
      this.buttonValue = data.buttonValue;
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
